var convertionRatiosObj = {
    GBP: 1,
    USD: 1,
    CAD: 1,
    NZD: 1,
    PLN: 5,
    BRL: 5,
    NOK: 10,
    RUB: 80,
    INR: 80,
    Ft: 300,
    UAH: 30,
    BRL: 5,
    JPY: 125,
    CLP: 1000,
    SOL: 5
  },
  currencies = {
    gb: 'GBP',
    ca: 'CAD',
    nz: 'NZD',
    pl: 'PLN',
    br: 'BRL',
    no: 'NOK',
    ru: 'RUB',
    in: 'INR',
    hu: 'Ft',
    ua: 'UAH',
    br: 'BRL',
    jp: 'JPY',
    ar: 'USD',
    bo: 'USD',
    cl: 'CLP',
    cr: 'USD',
    do: 'USD',
    ec: 'USD',
    gq: 'USD',
    sv: 'USD',
    gt: 'USD',
    hn: 'USD',
    ni: 'USD',
    pa: 'USD',
    py: 'USD',
    pe: 'SOL',
    uy: 'USD',
    ve: 'USD'
  };
export function initTournamentsPrizes() {
  let prizesElList = document.querySelectorAll('.tournament-prize');
  for (let i = 0, len = prizesElList.length; i < len; i++) {
    let prizeEl = prizesElList[i];
    if (!isNaN(prizeEl.innerText)) {
      prizeEl.classList.add('js-cms-static-conversion');
      prizeEl.innerHTML = getTournamentsPrizeConvertion(prizeEl.innerText);
    }
  }
}

export function getTournamentsPrizeConvertion(prize) {
  let currency = 'EUR';
  if (_CMS_USER_SESSION_ACTIVE == '1' && _CMS_USER_CURRENCY != '' && convertionRatiosObj[_CMS_USER_CURRENCY]) {
    currency = _CMS_USER_CURRENCY;
  } else if (currencies[_CMS_USERIP]) {
    currency = currencies[_CMS_USERIP];
  }
  let convertionRatio = currency != 'EUR' && convertionRatiosObj[currency] ? convertionRatiosObj[currency] : 1;
  if (currency == 'EUR') {
    if (_CMS_USERIP == 'de') {
      return parseInt(prize) * convertionRatio + '€';
    } else if (_CMS_USERIP == 'fi') {
      return parseInt(prize) * convertionRatio + ' €';
    } else {
      return '€' + parseInt(prize) * convertionRatio;
    }
  } else if (currency == 'GBP') {
    return '£' + parseInt(prize) * convertionRatio;
  } else if (currency == 'BRL') {
    return 'R$' + parseInt(prize) * convertionRatio;
  } else if (currency == 'JPY') {
    return '￥' + parseInt(prize) * convertionRatio;
  } else if (currency == 'SOL') {
    return 'S/ ' + parseInt(prize) * convertionRatio;
  } else if (currency == 'USD') {
    return '$' + parseInt(prize) * convertionRatio + ' USD';
  } else {
    return parseInt(prize) * convertionRatio + ' ' + currency;
  }
}
